export const parameters = {
	serviceUrl: 'https://briisk-i-dev-api.azure-api.net/bl',
	captchaKey: '6LeeTsMrAAAAANEOVxC4fMXdXZX2yzABk9SdvhsA',
	brandLabelSubscriptionKey: '6aeeca623d274b61bd75b25cd28d2cb8',
	bitpUrl: 'https://briisk-i-dev-web.azurewebsites.net',
	environment: 'dev',
	appInsightsConnectionString: 'InstrumentationKey=3bc787a4-b318-44ff-bddb-f0825c8d723a;IngestionEndpoint=https://southafricanorth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/;ApplicationId=0a9dd22e-4812-4b22-be9e-6507e725be9a'

	// serviceUrl: 'http://localhost:7071',
	// serviceUrl: 'https://briisk-i-dev-api.azure-api.net/bl',
	// captchaKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
	// brandLabelSubscriptionKey: '6aeeca623d274b61bd75b25cd28d2cb8',
	// bitpUrl: 'https://briisk-i-dev-web.azurewebsites.net',
	// environment: 'dev',
	// appInsightsConnectionString: ''
};
